
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/migration-guide/unifying-data",
      function () {
        return require("private-next-pages/events/migration-guide/unifying-data.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/migration-guide/unifying-data"])
      });
    }
  